import axios from 'axios';
import api from "../../api/axiosClient"

interface MapData{
    id: number,
    name: string
}


export const CreateOperationsMaps = async () => { 
        const sorter_map = await api.get<MapData[]>(`/sorter`)
        const belt_map = await api.get<MapData[]>(`/sorter/belt`)
        const recipe_map = await api.get<MapData[]>(`/sorter/recipe`, { params: { include_deleted: true } })
        const status_map = await api.get<MapData[]>(`/sorter/belt/schedule-status`)

        const sorterMap = new Map(sorter_map.data.map(s => [s.id, s.name]));
        const beltMap = new Map(belt_map.data.map(b => [b.id, b.name]));
        const recipeMap = new Map(recipe_map.data.map(r => [r.id, r.name]));
        const statusMap = new Map(status_map.data.map(s => [s.id, s.name]));

        return {"sorterMap":sorterMap , "beltMap":beltMap, "recipeMap":recipeMap, "statusMap":statusMap}
    } 

